import React, { useState } from 'react';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import useStyles from '../../styles/location';
import { AccessLevelType } from './LocationProperties';
import { addNewUser } from '../../services/apiService';
import { NewUserDetails } from '../../services/api';
import { getLocationsById } from '../../state/selectors';
import { themeProps } from '../../styles/theme';
import { useAppSelector } from '../../state/store';

interface CreateNewUserProps {
  locationId: string;
  setIsCreatingUser: (value: boolean) => void;
  refreshUsers: () => void;
}

function CreateNewUser({
  locationId,
  setIsCreatingUser,
  refreshUsers,
}: CreateNewUserProps): JSX.Element {
  const { classes } = useStyles();
  const [accessLevel, setAccessLevel] = useState<string | unknown>('readOnly');
  const [email, setEmail] = useState<string>('');
  const locationsById = useAppSelector(getLocationsById);
  const currentLocationName = locationsById.get(locationId)?.name ?? locationId;

  const addUser = () => {
    closeSnackbar();
    const newUserProps = {
      access_level: accessLevel,
      email,
    };
    const emailRegex = /\S+@\S+\.\S+/;
    if (emailRegex.test(email)) {
      addNewUser(locationId, newUserProps as NewUserDetails)
        .then(() => {
          refreshUsers();
          enqueueSnackbar('User successfully created', { variant: 'success' });
          setEmail('');
        })
        .catch((err) => enqueueSnackbar(err.cause, { variant: 'error', persist: true }));
    } else {
      enqueueSnackbar('Email is not in valid format', { variant: 'error', persist: true });
    }
  };

  return (
    <div className={classes.createUserContainer}>
      <Typography variant="h6" style={{ marginBottom: '10px' }}>
        Add New User
      </Typography>
      <TextField
        label="Location"
        value={currentLocationName}
        disabled
        className={classes.newUserTextField}
        variant="standard"
      />
      <TextField
        type="email"
        label="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className={classes.newUserTextField}
        variant="standard"
      />
      <Box mt="10px" mb="5px">
        <Select
          labelId="Access Level"
          onChange={(e) => setAccessLevel(e.target.value)}
          value={accessLevel}
          className={classes.newUserTextField}
          variant="standard"
        >
          {Object.entries(AccessLevelType).map((accessType) => (
            <MenuItem value={accessType[1]} key={accessType[0]}>
              {accessType[0]}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Box mt={2}>
        <Button variant={themeProps.btnVariant.default} onClick={addUser}>
          Add
        </Button>
        <Button className={classes.cancelBtn} onClick={() => setIsCreatingUser(false)}>
          Close
        </Button>
      </Box>
    </div>
  );
}

export default CreateNewUser;
